export default "__VITE_ASSET__DBuo9Z0o__"